import React from 'react';
import './Audience.css';
import Marquee from 'react-double-marquee';

const Audience = (props) => {
    return (
        <div className="audience container--full">
            <h3>Ideal for</h3>
            <div className='audience_wrap' style={{
                width: '100%',
                whiteSpace: 'nowrap',
            }}>
                <Marquee direction='left' speed={0.03} delay={0} childMargin={0}>
                    <span className="green"> Web3 devs</span><span>Rust</span><span className="green">Solidity</span><span>DevOps</span><span className="green"> Front-end</span><span>JavaScript</span><span className="green">TypeScript</span><span>Backend</span><span className="green"> Web3 devs</span><span>Rust</span><span className="green">Solidity</span><span>DevOps</span><span className="green"> Front-end</span><span>JavaScript</span><span className="green">TypeScript</span><span>Backend</span>
                </Marquee>
                <Marquee direction='left' speed={0.07} delay={0} childMargin={0}>
                    <span className="green">Java</span><span>Go</span><span className="green">Protocol engineers</span><span>Mobile</span><span className="green">Swift</span><span>Kotlin</span><span className="green">Web3 enthisuasts</span><span>Mobile</span><span className="green">Java</span><span>Go</span><span className="green">Protocol engineers</span><span>Mobile</span><span className="green">Swift</span><span>Kotlin</span><span className="green">Web3 enthisuasts</span><span>Mobile</span>
                </Marquee>
            </div>
        </div>
    );
};

export default Audience;